import Fretboard from "./Fretboard";
import FretboardConfig from "./FretboardConfig";
import Location from "./Location";

const guitarStrings = [
	new Location(4, 4),
	new Location(11, 3),
	new Location(7, 3),
	new Location(2, 3),
	new Location(9, 2),
	new Location(4, 2)
];

const bassStrings = [
	new Location(7, 2),
	new Location(2, 2),
	new Location(9, 1),
	new Location(4, 1)
];

const guitarDots = [
	[3, 3], [3, 5], [3, 7], [3, 9], [2, 12], [4, 12], [3, 15], [3, 17], [3, 19], [3, 21]
];

const bassDots = [
	[2, 3], [2, 5], [2, 7], [2, 9], [1, 12], [3, 12], [2, 15], [2, 17], [2, 19], [2, 21]
];

const guitarFretboard = new Fretboard("Guitar", "guitar", guitarStrings, guitarDots, 21);
const bassFretboard = new Fretboard("Bass guitar", "bass", bassStrings, bassDots, 21);

export const fretboardConfigs = [
	new FretboardConfig("Guitar and bass", [guitarFretboard, bassFretboard]),
	new FretboardConfig("Guitar", [guitarFretboard]),
	new FretboardConfig("Bass", [bassFretboard])
];
